import CryptoJS from 'crypto-js';

const secretKey = process.env.NEXT_PUBLIC_APP_SECRET_CIP_KEY;

function encryptInteger(data) {
    try {
        const jsonData = JSON.stringify(data);
        let ciphertext = CryptoJS.DES?.encrypt(jsonData, secretKey).toString();
        ciphertext = ciphertext.replace(/\//g, '-');
        return ciphertext;
    } catch (error) {
        console.error("Encryption error:", error);
        return null;
    }
}

function decryptInteger(ciphertext) {
    try {
        if (!ciphertext) return null;
        ciphertext = ciphertext.replace(/-/g, '/');
        const bytes = CryptoJS.DES.decrypt(ciphertext, secretKey);
        const originalText = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(originalText);
    } catch (error) {
        console.error("Decryption error:", error);
        return null;
    }
}

export { encryptInteger, decryptInteger };